import React from "react";

const About = () => {
  return (
    <div className="container padding">
      <div className="col-md-12">
        <div className="row mx-0">
          <p>
          <h1>Helping our community in need</h1>
          “Everybody can be great. Because anybody can serve. 
          You don’t have to have a college degree to serve. 
          You don’t have to make your subject and your verb agree to serve. 
          You don’t have to know the second theory of thermodynamics in physics to serve. 
          You only need a heart full of grace. A soul generated by love.”
           – Martin Luther King, Jr
          </p>
        </div>
      </div>
    </div>
  );
};

export default About;
